import {createContext, useContext} from 'react'
import PropTypes from 'prop-types'
import {useSimpleQuery} from '@frnt/base/hooks'
import {ResourceApiServiceProvider} from '../resource-api-service-provider'
import qs from 'qs'

const JobPostingsServiceContext = createContext(undefined)

const JobPostingsServiceProvider = ({
  children,
  baseApiHost,
  handleUnauthorized = () => {
    // Do nothing
  }
}) => {
  return (
    <ResourceApiServiceProvider
      Context={JobPostingsServiceContext}
      handleUnauthorized={handleUnauthorized}
      host={baseApiHost}
      valueCallback={(axios) => ({
        create: async (payload) => {
          const {data} = await axios.post(`/api/v1/content/job_postings`, payload)
          return data
        },
        get: async (id) => {
          const {data} = await axios.get(`/api/v1/content/job_postings/${id}`)
          return data
        },
        list: async (query) => {
          const {data} = await axios.get(
            `/api/v1/content/job_postings${qs.stringify(query, {
              addQueryPrefix: true
            })}`
          )
          return data
        },
        update: async (id, payload) => {
          const {data} = await axios.patch(`/api/v1/content/job_postings/${id}`, payload)
          return data
        },
        delete: async (id) => {
          const {data} = await axios.delete(`/api/v1/content/job_postings/${id}`)
          return data
        }
      })}>
      {children}
    </ResourceApiServiceProvider>
  )
}

JobPostingsServiceProvider.propTypes = {
  children: PropTypes.any,
  baseApiHost: PropTypes.string.isRequired,
  handleUnauthorized: PropTypes.func
}

const useJobPostingsService = () => {
  const context = useContext(JobPostingsServiceContext)
  if (context === undefined) {
    throw new Error('JobPostingsServiceContext was not provided. Make sure your component is a child of the JobPostingsServiceProvider.')
  }
  return context
}

const useJobPostingsQuery = ({query, ...otherProps}) => {
  const jobPostingsService = useJobPostingsService()
  return useSimpleQuery({
    queryKey: `job_postings-list-${JSON.stringify(query)}`,
    queryFn: async () => jobPostingsService.list(query),
    ...otherProps
  })
}

const useJobPostingQuery = ({id, enabled, ...otherProps}) => {
  const jobPostingsService = useJobPostingsService()
  return useSimpleQuery({
    queryKey: `job_postings-get-${id}`,
    queryFn: async () => jobPostingsService.get(id),
    enabled: enabled !== undefined ? enabled : !!id,
    ...otherProps
  })
}

export {JobPostingsServiceProvider, useJobPostingsService, useJobPostingsQuery, useJobPostingQuery}
